/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Passkey_Failed_BodyInputs */



/**
* | output |
* | --- |
* | "Try again, or sign in with an email link and add the passkey again in your account." |
*
* @param {Signin_Passkey_Failed_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const signin_passkey_failed_body = /** @type {((inputs?: Signin_Passkey_Failed_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Passkey_Failed_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Try again, or sign in with an email link and add the passkey again in your account.")
});